var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-campaign"},[_c('img',{staticClass:"error-icon",attrs:{"src":_vm.warnImg,"alt":"Ícone Erro"}}),_c('h1',[_vm._v("Adesão não encontrada")]),_c('h6',[_vm._v("Não existe adesão a campanhas.")])])}
var staticRenderFns = []

export { render, staticRenderFns }